import toast from "react-hot-toast";

import { OpenAPI } from "simplydo/interfaces";
import { Divider } from "simplydo/react/ui/divider";
import { H3, Subheader } from "simplydo/react/ui/header";

import actions from "actions";
import api from "api";
import { useAppDispatch, useAppSelector } from "store";

import { Slider } from "components/lib/UI";

const markStyle = { marginTop: 10, marginRight: 10 };

const sliderMarks = [
  { label: "Weekly", key: "weekly" as const, value: 0, style: markStyle },
  { label: "Daily", key: "daily" as const, value: 1, style: markStyle },
  { label: "Hourly", key: "hourly" as const, value: 2, style: markStyle },
  { label: "Instant", key: "instant" as const, value: 3, style: markStyle },
];

export const NotificationFrequency = () => {
  const user = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();

  const onSubToggled = (subs: OpenAPI.Schemas["User"]["eventSubscriptions"]) =>
    dispatch(actions.user.toggleEventSubscription(subs));

  const emailFrequency = user?.eventSubscriptions?.notificationFrequency?.email;

  const sliderValue = Object.values(sliderMarks).find(
    (m) => m.key === emailFrequency,
  );

  const onSliderChange = (value: number) => {
    if (!user?._id) return;
    const newSliderValue = sliderMarks[value];
    if (!newSliderValue) {
      return;
    }

    onSubToggled({
      ...user.eventSubscriptions,
      notificationFrequency: { email: newSliderValue.key },
    });
    api.users.updateNotificationPreferences(
      user._id,
      ["notificationFrequency"],
      // @ts-expect-error notificationFrequency payload shape differs from subscription methods
      { email: newSliderValue.key },
      () => {
        toast.success("Notification frequency updated");
      },
      (err) => toast.error(err.message),
    );
  };

  return (
    <div>
      <Divider />
      <H3>
        Notification frequency
        <Subheader>
          Adjust the frequency for how often you receive email updates. Emails
          will summarise the events during the time period.
        </Subheader>
      </H3>
      <Slider
        min={0}
        max={3}
        marks={sliderMarks}
        value={sliderValue?.value ?? 3}
        onChange={(value) => onSliderChange(value)}
        style={{ marginBottom: 50 }}
      />
      <Divider />
    </div>
  );
};

export default NotificationFrequency;
